import FilterBar from './FilterBar.connect';
import * as FilterBarSelectors from './FilterBar.selectors';

FilterBar.selectors = FilterBarSelectors;

export default FilterBar;
